import config from './_config'
import paths from './_paths'
const mode = process.env.NODE_ENV

export default (name, params) => {
  if (mode === 'development') {
    return config().get(paths[name], params).catch(error => {
      throw new Error(`Api Service GET ${paths[name]} Failed: ${error}`)
    })
  }

  return config().post(paths[name], params).catch(error => {
    if (error.response.status === 419) {
      window.location.reload()
      return
    }
    throw new Error(`Api Service POST ${paths[name]} Failed: ${error}`)
  })
}
